import * as React from "react";
import { Row, Col, Button } from "react-bootstrap";
import { IReport } from "../../../common/sharedTypes";
import ViewAllButton from "../../DocumentViewer/ViewAllButton";
import DriverPdfsButton from "../../shared/DriverPdfsButton/DriverPdfsButton";
export interface IInfoButtonBarProps {
  report: IReport;
  handleOpenPdf?: () => void;
  sendToManagementQueue?: () => void;
  createFrontSheetButton?: React.ReactNode | null;
}

export default class InfoButtonBar extends React.Component<IInfoButtonBarProps> {
  public render() {
    const { createFrontSheetButton } = this.props;
    return (
      <React.Fragment>
        <Row>
          <Col>
            <ViewAllButton reportId={this.props.report.id} className="openReportPdfButton" />

            <Button
              variant="secondary"
              size="sm"
              onClick={() => this.props.handleOpenPdf()}
              className="openReportPdfButton"
            >
              Open Report PDF
            </Button>

            <DriverPdfsButton report={this.props.report} />
            {createFrontSheetButton && createFrontSheetButton}
            <Button
              variant="secondary"
              size="sm"
              onClick={() => this.props.sendToManagementQueue()}
              className="openReportPdfButton"
            >
              Send to Management Queue
            </Button>
          </Col>
          <Col>Crash Key: {this.props.report.keywords.originalCrashKey}</Col>
        </Row>
      </React.Fragment>
    );
  }
}
